import React from 'react'
import './Footer.css'

const Footer = () => {
    return (
        <footer className='d-flex bg-dark text-white d-flex align-items-center justify-content-center'>
            <span>Code and design by Yaroslav Shelekhan</span>
        </footer>
    );
};

export default Footer;
